"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isValidAccuracy = (value) => [
    'balancedPowerAccuracy',
    'highAccuracy',
    'lowPower',
].includes(`${value}`);
const buildCallableGetLocation = (args) => async ({ entryVars: { desiredAccuracy = 'balancedPowerAccuracy', permissionRequestTile = 'Access your location', permissionRequestMessage = 'We need your location in order to function properly', }, functionId, callbacks, executeProcesses, }) => {
    try {
        const accuracy = desiredAccuracy === '' ? 'balancedPowerAccuracy' : desiredAccuracy;
        if (!isValidAccuracy(accuracy)) {
            throw new Error(`Invalid desiredAccuracy: ${desiredAccuracy}`);
        }
        const { longitude, latitude } = await args.onGetLocation({
            desiredAccuracy: accuracy,
            permissionRequestTile: `${permissionRequestTile}`,
            permissionRequestMessage: `${permissionRequestMessage}`,
        });
        executeProcesses(functionId, callbacks.geoSuccess, { longitude, latitude });
    }
    catch (error) {
        executeProcesses(functionId, callbacks.geoError, error instanceof Error ? error.message : `${error}`);
    }
};
exports.default = buildCallableGetLocation;
